import { ProductionRecipeItem, ReceivingItem } from "./employeeProductionTypes";

export function findRecipeForReceivingItem(
  recipes: ProductionRecipeItem[],
  item: ReceivingItem,
): ProductionRecipeItem | undefined {
  return recipes.find(
    (recipe) =>
      recipe.bom_id === item.ingredient_id ||
      recipe.ingredient_id === item.ingredient_id,
  );
}

export function suggestedIngredientAmount(
  recipe: ProductionRecipeItem,
  item: ReceivingItem,
): number {
  const required = recipe.amount_required ?? item.in_stock;
  return Math.max(0, Math.min(required, item.in_stock));
}

export function lastNine(barcode?: string | null): string {
  return barcode?.slice(-9) || "N/A";
}
